export const appointmentUserParams = {
  service: "service",
  pet: "pet",
  to: "to",
  from: "from",
  status: "status",
  page: "page",
  sort: "sort",
};

export const futurePastFilterKeys = [
  appointmentUserParams.service,
  appointmentUserParams.pet,
  appointmentUserParams.to,
  appointmentUserParams.from,
  appointmentUserParams.status,
  appointmentUserParams.sort,
];